var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "list" }, [
    _c(
      "ul",
      { staticClass: "list-items" },
      _vm._l(_vm.items, function(item) {
        var _obj
        return _c(
          "li",
          { key: item[_vm.keyField], class: { "list-item": true } },
          [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.selectItem(item)
                  }
                }
              },
              [
                _c(
                  "div",
                  {
                    class: ((_obj = { info: true }),
                    (_obj[item.status.toLowerCase()] = item.status),
                    _obj)
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [_vm._t("icon", null, { item: item })],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col" }, [
                      _c(
                        "span",
                        { staticClass: "title" },
                        [_vm._t("title", null, { item: item })],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "description" },
                        [_vm._t("description", null, { item: item })],
                        2
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("next-arrow-icon-neutral")
              ],
              1
            )
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }